import React from "react";
import { InlineNotification } from "carbon-components-react";

import { AppShape, OwnedRealEstate } from "@eave/shared/types/api";

interface Props {
  app: AppShape;
  ownedRealEstate: OwnedRealEstate[];
}

const NotificationsForTradeIn: React.FC<Props> = ({ app, ownedRealEstate }) => {
  const appHasTradeInOrder = app.hl_order && app.hl_order.cash_trade_in;
  const reoMarkedAsTradeIn = ownedRealEstate.some(reo => reo.is_trade_in);

  if (appHasTradeInOrder && !reoMarkedAsTradeIn) {
    return (
      <InlineNotification
        kind="info"
        hideCloseButton
        title="Latest HL order indicates that a REO may be a trade-in"
        subtitle={`Found a trade-in property with address: ${app.hl_order.cash_trade_in.departing_residence_address}`}
      />
    );
  }

  if (appHasTradeInOrder && reoMarkedAsTradeIn && app.hl_order.cash_trade_in.stage === "failed") {
    return (
      <InlineNotification
        kind="warning"
        hideCloseButton
        title="REO may no longer be a trade-in"
        subtitle={`Found a failed trade-in deal for property address: ${app.hl_order.cash_trade_in.departing_residence_address}`}
      />
    );
  }

  if (!appHasTradeInOrder && reoMarkedAsTradeIn) {
    return (
      <InlineNotification
        kind="warning"
        hideCloseButton
        title="REO may no longer be a trade-in"
        subtitle="Latest HL Order indicates that there are no trade-in deals, but found an REO marked as trade-in"
      />
    );
  }

  // need to return jsx
  return <></>;
};

export default NotificationsForTradeIn;
